import type { ReactNode } from 'react';

export const symbol_nest_farsight_eco: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M479-309q71 0 120.5-49.5T649-479v-140q0-13-8.5-21.5T619-649H479q-71 0-120.5 49.5T309-479q0 26 8.5 50.5T340-382l-22 22q-9 9-9 21t9 21q9 9 21 9t21-9l22-22q22 14 46.5 22.5T479-309Zm1-61q-14 0-27-4t-27-9l95-96q9-9 9-21t-9-21q-9-9-21-9t-21 9l-96 95q-5-14-9-27t-4-27q0-46 32-78t78-32h110v110q0 46-32 78t-78 32Zm20-130ZM480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
		/>
	</svg>
);
